import type { Components, Theme } from "@mui/material/styles";

export const MuiTableHead: Components<Theme>["MuiTableHead"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      fontSize: theme.typography.fontSizeMd,
      fontWeight: theme.typography.fontWeightBold,
    }),
  },
};
